var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.661,
    height: 52.348,
    viewBox: "0 0 309.661 52.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.622 -203.007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.622 203.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.407,204.994a25.1,25.1,0,0,1,6.356,3.066,11.108,11.108,0,0,0,9.62,12.057A25.172,25.172,0,0,1,134.945,227a11.109,11.109,0,0,0-3.429,15.035,25.46,25.46,0,0,1-2.158,3.094,22.233,22.233,0,0,0-6.19-7.456,15.951,15.951,0,1,0-26.953,0,22.066,22.066,0,0,0-6.191,7.454,25.532,25.532,0,0,1-2.155-3.09A11.11,11.11,0,0,0,84.439,227,25.111,25.111,0,0,1,86,220.116a11.107,11.107,0,0,0,9.622-12.057,25.157,25.157,0,0,1,6.356-3.066,11.109,11.109,0,0,0,15.428,0m-.54-1.987a9.357,9.357,0,0,1-14.348,0,26.977,26.977,0,0,0-8.784,4.238,9.356,9.356,0,0,1-8.949,11.211,26.94,26.94,0,0,0-2.164,9.51,9.354,9.354,0,0,1,3.189,13.984,27.11,27.11,0,0,0,4.739,6.363,20.653,20.653,0,0,1,.823-1.964,20.221,20.221,0,0,1,7.293-8.264,14.2,14.2,0,1,1,22.053,0,20.269,20.269,0,0,1,8.113,10.231,27.191,27.191,0,0,0,4.742-6.366,9.353,9.353,0,0,1,3.187-13.982,26.941,26.941,0,0,0-2.164-9.511,9.357,9.357,0,0,1-8.947-11.212,26.972,26.972,0,0,0-8.784-4.236Z",
    transform: "translate(-82.622 -203.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M102.6,213.659a8.789,8.789,0,1,1-8.789,8.789,8.8,8.8,0,0,1,8.789-8.789m0-1.752a10.541,10.541,0,1,0,10.541,10.541A10.542,10.542,0,0,0,102.6,211.907Z",
    transform: "translate(-75.528 -196.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.622,226.554a15.952,15.952,0,0,0,16.836,0,14.905,14.905,0,0,1,5.76,7.428,25.059,25.059,0,0,1-6.9,3.274,10.792,10.792,0,0,0-14.55,0,25.087,25.087,0,0,1-6.9-3.274,15.209,15.209,0,0,1,.618-1.479,14.948,14.948,0,0,1,5.144-5.95m.04-2.088a16.836,16.836,0,0,0-7.852,10.205,26.983,26.983,0,0,0,9.471,4.548,9.048,9.048,0,0,1,13.514,0,26.964,26.964,0,0,0,9.471-4.546,16.765,16.765,0,0,0-7.849-10.2,14.189,14.189,0,0,1-16.756,0Z",
    transform: "translate(-77.969 -186.871)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.638 210.828)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M134.982,226.3l-3.739,4.036v11.81h-5.231V207.813h5.231v16.093l14.35-16.093h6.628l-13.853,14.9,15.247,19.434h-6.675Z",
    transform: "translate(-126.012 -207.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.189,242.216l-6.428-12.906h-9.019v12.856h-5.231V207.784H164.26c7.125,0,11.559,4.086,11.559,10.962,0,5.082-2.491,8.572-6.925,9.916l7.176,13.555Zm-15.447-17.39h9.268c4.436,0,6.579-2,6.579-6.081,0-3.986-2.193-6.379-6.579-6.379h-9.268Z",
    transform: "translate(-108.342 -207.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M173.664,207.784h22.623v4.534H178.9v10.364h15.6v4.536H178.9v10.364h17.391v4.583H173.664Z",
    transform: "translate(-90.181 -207.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.382,211.771,200.8,237.632h20.578v4.534H194.176V238.38L214.9,212.318H195.273v-4.534h26.109Z",
    transform: "translate(-74.757 -207.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.423,225.211c0-10.364,5.58-17.74,15.6-17.74,7.025,0,13.9,4.536,14.15,13.2h-4.883c-.6-5.331-3.986-8.471-9.219-8.471-6.477,0-10.513,4.884-10.513,12.8,0,8.124,4.086,13.155,10.613,13.155a9.029,9.029,0,0,0,9.119-8.52h4.883c-.3,8.67-7.074,13.253-14.1,13.253C222,242.9,216.423,235.525,216.423,225.211Z",
    transform: "translate(-58.029 -207.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.23,225.189c0-10.813,6.03-17.689,15.9-17.689,9.814,0,15.893,6.876,15.893,17.689s-6.079,17.688-15.893,17.688C247.26,242.877,241.23,236,241.23,225.189Zm26.41,0c0-8.422-4.087-13.006-10.513-13.006s-10.515,4.585-10.515,13.006c0,8.271,4.085,13,10.515,13S267.64,233.46,267.64,225.189Z",
    transform: "translate(-39.376 -207.449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.dba4782f781b9b491fa1e28e83c84b0e.svg";
export { ForwardRef as ReactComponent };